export enum PatientAttachmentStatus {
  open = 'open',
  markedAsInvalid = 'marked_as_invalid',
  closed = 'closed',
  inOcr = 'in_ocr',
  llmProcessing = 'llm_processing',
}
